$(document).ready(function() {

    

    var menuIsOpen = false;

    var ipstudio_func = {
      toggleMobileMenu: function(){
        if ( menuIsOpen ) {
          $('.mobile-menu-icon').removeClass('is-open-menu');
          $('.ebf-mobile-menu-wrapper').removeClass('mobile-menu-open');
          menuIsOpen = false;
          $('body').removeClass('no-scroll');
        } else {
          $('.mobile-menu-icon').addClass('is-open-menu');
          $('.ebf-mobile-menu-wrapper').addClass('mobile-menu-open');
          menuIsOpen = true;
          $('body').addClass('no-scroll');
        }
      }
    };
    
    // When hovering over a menu item with children
    $('#js-navigation-menu .menu-item-has-children').hover(
        function() {
            // Show the submenu by adding 'is-visible' class
            $(this).children('.sub-menu').addClass('is-visible');
        },
        function() {
            // Hide the submenu by removing 'is-visible' class
            $(this).children('.sub-menu').removeClass('is-visible');
        }
    );

    // When hovering over a menu item with children
    $('#js-navigation-menu-mobile .menu-item-has-children a').on('click', function( e ){
      console.log( 'clicking menu item ');
      e.preventDefault();
      $this = $( this );

      
      $this.parents('.menu-item-has-children').find('.sub-menu').toggleClass('is-visible');
      $this.parents('.menu-item-has-children').toggleClass('menu-is-visible');

      
    });


    $('.mobile-menu-icon').on('click', function(e){
      e.preventDefault();
      ipstudio_func.toggleMobileMenu();
    });
});